//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { IFRAMES } from '@/js/constants';
export default {
  name: 'ContMonitoring',
  data: function data() {
    return {
      srcEmbebed: IFRAMES['ContMonitoring']
    };
  }
};